// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"9f0b7f60","81":"9f0b7f60","222":"9f0b7f60","354":"9f0b7f60","386":"9f0b7f60","691":"9f0b7f60","792":"9f0b7f60"}[chunkId] + ".chunk.css";
};